/**
 * Singleton que persiste la ruta y params de un deeplink pendiente.
 * Se usa cuando el deeplink llega antes de que el usuario esté logueado:
 * se guarda acá y se consume post-login.
 */

export interface DeepLinkParams {
  [key: string]: string
}

class DeepLinkStore {
  private _pendingRoute: string | null = null
  private _params: DeepLinkParams = {}

  get pendingRoute (): string | null { return this._pendingRoute }
  get params (): DeepLinkParams { return this._params }

  setPendingRoute (route: string): void {
    this._pendingRoute = route
  }

  setParams (params: DeepLinkParams): void {
    this._params = { ...this._params, ...params }
  }

  consumePendingRoute (): string | null {
    const route = this._pendingRoute
    this._pendingRoute = null
    return route
  }

  consumeParams (): DeepLinkParams {
    const params = { ...this._params }
    this._params = {}
    return params
  }

  clear (): void {
    this._pendingRoute = null
    this._params = {}
  }
}

export const deepLinkStore = new DeepLinkStore()
